import axios from 'axios';

export const DEFAULT_PAGE_SIZE = 6;

export const blogLoader = axios.create({
  baseURL: process.env.REACT_APP_STRAPI_BACKEND_URL,
});
